const getCookieValue = (documentCookies, cookieName) => {
    function escape(s) {
        return s.replace(/([.*+?^$(){}|[\]/\\])/g, '\\$1');
    }
    const match = documentCookies.match(RegExp(`(?:^|;\\s*)${escape(cookieName)}=([^;]*)`));
    return match ? match[1] : null;
};

const retrieveOuterDomain = (url) => {
    const leadingSubdomainOrDotRegex = /[^.]+|\./;
    return url.replace(leadingSubdomainOrDotRegex, '');
};

function trim(s) {
    const leadingTrailingWhitespaceRegex = /^\s+|\s+$/g;
    return s.replace(leadingTrailingWhitespaceRegex, '');
}

function isGACookie(cookieName) {
    const gaRegex = /^_g(a|id).*/;
    return gaRegex.test(cookieName);
}

function getCookie(checkName) {
    // first we'll split this cookie up into name/value pairs
    // note: document.cookie only returns name=value, not the other components
    const aAllCookies = document.cookie.split(';');
    let aTempCookie = '';
    let cookieName = '';
    let cookieValue = '';

    for (let i = 0; i < aAllCookies.length; i++) {
        // now we'll split apart each name=value pair
        aTempCookie = aAllCookies[i].split('=');

        // and trim left/right whitespace while we're at it
        cookieName = aTempCookie[0].replace(/^\s+|\s+$/g, '');

        // if the extracted name matches passed checkName
        if (cookieName === checkName) {
            // we need to handle case where cookie has no value but exists (no = sign, that is):
            if (aTempCookie.length > 1) {
                cookieValue = unescape(aTempCookie[1].replace(/^\s+|\s+$/g, ''));
            }
            // note that in cases where cookie is initialized but no value, null is returned
            return cookieValue;
        }
        aTempCookie = null;
        cookieName = '';
    }
    return null;
}

const clearCookies = (predicateFn) => () => {
    // https://blog.tcs.de/delete-clear-google-analytics-cookies-with-javascript/
    function clearCookie(name, domain, path) {
        if (getCookie(name)) {
            const newDomain = domain || document.domain;
            const newPath = path || '/';

            const expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() - 1);

            document.cookie = `${name}=; expires=${expiryDate}; domain=${newDomain}; path=${newPath}`;
        }
    }

    function confirmCookieIsClearedElseTryDifferentDomain(cookieName) {
        let differentDomain = document.location.hostname;
        while (getCookieValue(document.cookie, cookieName) !== undefined && differentDomain) {
            clearCookie(cookieName, differentDomain, '/');
            differentDomain = retrieveOuterDomain(differentDomain);
        }
    }

    return document.cookie
        .split(';')
        .map((cookie) => cookie.split('=')[0])
        .map(trim)
        .filter(predicateFn)
        .forEach(confirmCookieIsClearedElseTryDifferentDomain);
};

const clearAnalyticsCookies = clearCookies(isGACookie);

function init() {
    window.addEventListener('DOMContentLoaded', () => {
        const trigger = document.querySelector('#clearAnalyticalCookies');
        if (trigger) {
            clearAnalyticsCookies();
        }
    });
}

export { getCookieValue, retrieveOuterDomain, clearCookies, trim, isGACookie, clearAnalyticsCookies, init };
